import type { UpdateAcademyAnnouncementBannerParams } from '../../api';
import { useEffect } from 'react';
import {
  useCreateAcademyAnnouncementBannerMutation,
  useGetAcademyAnnouncementBannersQuery,
  useUpdateAcademyAnnouncementBannerMutation,
} from '../../api';
import { AnnouncementBannerSectionEditorSettings } from './AnnouncementBanner.theming';

export const AnnouncementBannerSettingsTabContent = ({
  academyId,
  visible,
  onChange,
}: {
  academyId: string;
  visible: boolean;
  onChange: () => void;
}) => {
  const {
    data: announcementBars = [],
    isLoading,
    isError,
  } = useGetAcademyAnnouncementBannersQuery(academyId, {
    enabled: visible,
  });
  const { settings: AnnouncementBannerSettings } = AnnouncementBannerSectionEditorSettings;
  const createAcademyAnnouncementBanner = useCreateAcademyAnnouncementBannerMutation(academyId).mutate;
  const updateAcademyAnnouncementBanner = useUpdateAcademyAnnouncementBannerMutation(academyId).mutate;

  const defaultAnnouncementBar = announcementBars[0];

  const handleUpdate = (data: UpdateAcademyAnnouncementBannerParams) => {
    updateAcademyAnnouncementBanner(
      {
        id: defaultAnnouncementBar.id,
        ...data,
      },
      {
        onSuccess: onChange,
      },
    );
  };

  useEffect(() => {
    if (isLoading || isError) return;

    if (announcementBars.length === 0) {
      createAcademyAnnouncementBanner(
        {
          title: 'DEFAULT',
        },
        {
          onSuccess: onChange,
        },
      );
    }
  }, [announcementBars, createAcademyAnnouncementBanner, isError, isLoading, onChange]);

  if (isLoading || !defaultAnnouncementBar) return null;

  return (
    <AnnouncementBannerSettings
      onChange={handleUpdate}
      settings={{
        startTime: defaultAnnouncementBar?.startTime,
        endTime: defaultAnnouncementBar?.endTime,
        themeSettings: defaultAnnouncementBar?.themeSettings,
      }}
    />
  );
};
